import React from 'react'
import { get } from 'lodash'
import { setPlaySourcePrefix } from '~/tools/analytics/cleverTap'

class CarouselItem extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      items: props.data && props.data.contentData
    }
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(title){
    setPlaySourcePrefix('Carousel')
  }

  render() {
    var item = this.props.item
    var gist = item.gist
    const hideInfo = get(this.props.layoutSettings, 'noInfo')
    var url = `${(gist.videoImageUrl || gist.landscapeImageUrl || get(window.settings, 'images.placeholderCover'))}?impolicy=resize&w=${this.props.maxWidth}&h=${this.props.maxWidth * 0.67}`

    return (
      <a onClick={_ => this.handleClick(gist.title)} className="carousel-item" href={gist.permalink}>
        <div className="image">
          <img 
            src={url} 
            data-src={url} 
            className="lazy"
            alt={gist.title}
          />
        </div>
        <div className="play-icon site-color"><i className="ion-ios-play" /></div>
        {!hideInfo && <div className="foot">
          <div className="info">
            <span className="title">{gist.title}</span>
            <span className="more">
              {gist.runtime && Math.ceil(gist.runtime / 60) + 'mins | '}
              {gist.year && gist.year + ' |'}
              {gist.primaryCategory && gist.primaryCategory.title && gist.primaryCategory.title}
            </span>
          </div>
          <div onClick={_ => this.handleClick(gist.title)} className="cta" href={gist.permalink}>Watch Now</div>
        </div>}
      </a>
    )
  }
}

export default CarouselItem;
